import { components } from "src/strapi/schema";

export const allReferences = {
  id: 0,
  name: "Vše",
  slug: "vse",
};

export const sortCategories = (
  categories: components["schemas"]["Category"][],
) => {
  return [
    allReferences,
    ...categories.sort((a, b) => {
      if (a.slug === "ostatni") return 1;
      if (b.slug === "ostatni") return -1;
      if (!a.id || !b.id) return 0;
      return a.id - b.id;
    }),
  ];
};
